import { render } from "./FooterCom.vue?vue&type=template&id=17b38786&scoped=true"
const script = {}

import "./FooterCom.vue?vue&type=style&index=0&id=17b38786&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b38786"]])

export default __exports__